// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailedPicture_block__aIy4g article-wrapper","picture":"DetailedPicture_picture__x8Hy3","sign":"DetailedPicture_sign__8S8gK"};